$(document).on('click', '.event-entry-js', function() {
  let $eventBlock = $(this).closest('.anons-grid__item');
  let eventId = parseInt($eventBlock.data('id'));
  let eventTitle = $eventBlock.find('.anons-grid__item-title').text();
  let eventTimeLabel = $eventBlock.find('time').text();
  let subtitle = `${eventTitle} <br> ${eventTimeLabel}`;

  openRecordFormModal({
    title: 'Запись на мероприятие',
    subtitle,
    submitCallback({e, form}) {
      e.preventDefault();

      form.querySelectorAll('input').forEach(input => {
        input.changed = true;
      });

      if (!form.validate()) {
        return;
      }

      let data = $(form).serialize() +
        '&event_id=' + eventId +
        '&title=' + 'Новая запись на мероприятие. ' + subtitle +
        '&page=' + document.location.href;

      $.post('/wp-json/api/v1/events/entry', data, function() {
        if (typeof form.submitCallback === 'function') {
          form.submitCallback();
        }

        openModal('Спасибо за заявку. В ближайшее время мы с вами свяжемся');
      });
    }
  });
});